import { c as e } from "react/compiler-runtime";
import { createContext as t, useContext as n, useState as r } from "react";
import i from "@tcc-online/assets/colors/palette.json";
import { jsx as a } from "react/jsx-runtime";
// src/index.tsx
var o = {
	primaryColor: "#e26856",
	primaryDarkColor: "#871211",
	primaryHighColor: "#cd2c1b",
	secondaryColor: "#8b1713",
	surfaceColor: "#fff",
	disabledColor: "#d3d2d2",
	backgroundColor: "#f2f2f2",
	borderColor: "#ccc",
	textColor: "#000",
	textLightColor: "#fff",
	textDisabledColor: "#918f90",
	textGrayColor: "#7D7A7A",
	successColor: "#32a468",
	errorColor: "#cd2c1b",
	warningColor: "#f0b310",
	borderRadius: 5,
	...i
}, s = t([o, () => {}]);
function c(t) {
	let n = e(9), i;
	n[0] !== t.defaultTheme || n[1] !== t.theme ? (i = () => Object.assign({}, { ...t.defaultTheme || o }, { ...t.theme ?? {} }), n[0] = t.defaultTheme, n[1] = t.theme, n[2] = i) : i = n[2];
	let [c, l] = r(i), [u, d] = r(t.theme);
	t.theme !== u && (d(t.theme), t.theme !== void 0 && l((e) => Object.assign({}, { ...e }, { ...t.theme })));
	let f;
	n[3] === Symbol.for("react.memo_cache_sentinel") ? (f = (e) => {
		l((t) => Object.assign({}, { ...t }, { ...e }));
	}, n[3] = f) : f = n[3];
	let p = f, m;
	n[4] === c ? m = n[5] : (m = [c, p], n[4] = c, n[5] = m);
	let h;
	return n[6] !== t.children || n[7] !== m ? (h = /* @__PURE__ */ a(s.Provider, {
		value: m,
		children: t.children
	}), n[6] = t.children, n[7] = m, n[8] = h) : h = n[8], h;
}
function l() {
	return n(s);
}
export { c as default, l as useTheme };

//# sourceMappingURL=index.js.map